import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../../widgets/form/InputSelectSF'
import InputTextSF from '../../../../widgets/form/InputTextSF'

const DirectorExternalStatusModalUI = ({
  context, updateMode, submitted, selectedDirectorName,
  onSubmit, onCancelClick,
  errorList, successMsg, setErrorList,
  statusList, status, onStatusChange, statusError, setStatusError,
  reuploadMessage, onReuploadMessageChange, reuploadMessageError, setReuploadMessageError,
  waivedMessage, onWaivedMessageChange, waivedMessageError, setWaivedMessageError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel={`Update Status — ${selectedDirectorName || 'Director'}`}
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectSF
      type='select'
      name='status'
      label='Status'
      required={true}
      value={status}
      onChange={onStatusChange}
      optionList={statusList}
      error={statusError}
      setError={setStatusError}
    />

    {status === 'reviewed_and_requires_resubmission' &&
      <InputTextSF type='text' name='reuploadMessage' label='Resubmission reason'
        required={true} maxLength={100}
        value={reuploadMessage} onChange={onReuploadMessageChange}
        error={reuploadMessageError} setError={setReuploadMessageError}
      />
    }

    {status === 'waived' &&
      <InputTextSF type='text' name='waivedMessage' label='Waived message'
        required={true} maxLength={100}
        value={waivedMessage} onChange={onWaivedMessageChange}
        error={waivedMessageError} setError={setWaivedMessageError}
      />
    }
  </ModalFormUI>

export default DirectorExternalStatusModalUI